import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/ladmin'
import './stylus/main.styl'
import App from './App.vue'
import store from './store/index'
import router from './router/index'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import './utils/accessDeny'
import rules from './utils/rules'
import reg from './utils/reg'
import echarts from 'echarts'
import periodCheck from './views/Charging/RuleConfig/periodCheck'
Vue.config.productionTip = false
Vue.prototype.$rules = rules
Vue.prototype.$reg = reg
Vue.prototype.$echarts = echarts
Vue.prototype.$periodCheck = periodCheck
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
